export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Construction Layout Design',
      description: 'Comprehensive layout design services for residential and commercial construction projects throughout Vancouver, Burnaby, Surrey, and Victoria.',
      features: ['Site Planning', 'Layout Coordination', 'Construction Sequencing', 'Quality Control']
    },
    {
      icon: 'ri-hammer-line',
      title: 'Construction Formwork Systems',
      description: 'Expert formwork design and consultation for concrete structures, ensuring efficiency and cost-effectiveness in your construction projects.',
      features: ['Formwork Planning', 'Technical Consultation', 'Load Analysis', 'Construction Support']
    },
    {
      icon: 'ri-draft-line',
      title: 'Formwork Drawing Services',
      description: 'Detailed technical drawings and documentation for formwork systems, providing clear guidance for construction teams and regulatory compliance.',
      features: ['Technical Drawings', 'CAD Documentation', 'Detail Specifications', 'As-Built Drawings']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Construction Design Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialized construction layout design and formwork services for projects across British Columbia, 
            backed by over 20 years of industry expertise and civil engineering knowledge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl p-8 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Service Areas</h4>
              <p className="text-gray-600">Vancouver, Burnaby, Surrey, Victoria and surrounding BC areas</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Fast Response</h4>
              <p className="text-gray-600">Quick project assessment and proposal delivery within 24-48 hours</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Licensed & Insured</h4>
              <p className="text-gray-600">Fully licensed and insured with comprehensive coverage</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
